import script from "./New.vue?vue&type=script&setup=true&lang=js"
export * from "./New.vue?vue&type=script&setup=true&lang=js"

import "./New.vue?vue&type=style&index=0&id=58d09972&scoped=true&lang=scss"

import exportComponent from "D:\\obj\\komanch\\web-company\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58d09972"]])

export default __exports__